import React from "react";
import activeStar from '@images/starActive.png'
import star from "@images/starUnActive.png";

interface StarRatingProps {
  rating: number;
  index?: number;
}

const StarRating: React.FC<StarRatingProps> = ({ rating }) => {
  const defaultRatings = new Array(5).fill(0);

  return (
    <div className="flex">
      {defaultRatings.map((rate, mapIndex) => {
        return (
          <img
            alt="star"
            key={mapIndex}
            src={Math.round(rating) > mapIndex ? activeStar : star}
            className=" h-4 w-auto mx-0.5"
          />
        );
      })}
    </div>
  );
};

export default StarRating;
